import { render } from "./instruction-details.vue?vue&type=template&id=cff091c6&scoped=true"
import script from "./instruction-details.vue?vue&type=script&lang=js"
export * from "./instruction-details.vue?vue&type=script&lang=js"

import "./instruction-details.vue?vue&type=style&index=0&id=cff091c6&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cff091c6"]])

export default __exports__